import { useScreenSize } from '../hooks/useScreenSize';
import React from 'react';

const NotFound: React.FC = () => {
  const { isTablet } = useScreenSize();

  return (
    <div className="grid-padding-lr">
      <div className="header-container flex-row-align">
        <div
          className={`${isTablet ? 'flex-colomn align-center gap-2' : 'flex-row space-evenly'} align-items w-100 ptb-1`}
        >
          <div>
            <h1 className="h1-mobile">404 - Page Not Found</h1>
            <p>The page you are looking for does not exist or you do not have access.</p>
          </div>
          <div className="logout flex-row-align">
            <a className="btn btn-second-color" href="/">
              Go back
            </a>
            <a className="btn btn-second-color" href="/login">
              Login
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
